import { DropperProps } from "../ui/Popover/PopoverBody";
import { stores } from "../utils/store";

export function openDropper(dropperParams: DropperProps) {
    stores.UI.dropper.set(dropperParams);
}

export function closeDropper() {
    stores.UI.dropper.set(undefined as any);
}